/**
 * Staff Tracking Service
 * Re-exports all work-tracking APIs + adds attendance-specific calls.
 */

import axios from 'axios';
import { baseUrl } from '../../config';

export * from '../sn_work_tracking/workTrackingService';

const ATT_BASE = `${baseUrl}/staff-tracking/attendance`;

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
  },
});

export const getDailyAttendance = async (date) => {
  try {
    const url = date ? `${ATT_BASE}/daily?date=${date}` : `${ATT_BASE}/daily`;
    const res = await axios.get(url, getAuthHeaders());
    return res.data;
  } catch (err) {
    throw err.response?.data || err.message;
  }
};

export const getMonthlyCalendar = async (staff_id, year, month) => {
  try {
    const res = await axios.get(
      `${ATT_BASE}/calendar/${staff_id}?year=${year}&month=${month}`,
      getAuthHeaders()
    );
    return res.data;
  } catch (err) {
    throw err.response?.data || err.message;
  }
};

export const getMonthlyReport = async (year, month) => {
  try {
    const res = await axios.get(
      `${ATT_BASE}/report?year=${year}&month=${month}`,
      getAuthHeaders()
    );
    return res.data;
  } catch (err) {
    throw err.response?.data || err.message;
  }
};

export const getWeeklySummary = async (staff_id) => {
  try {
    const res = await axios.get(`${ATT_BASE}/weekly/${staff_id}`, getAuthHeaders());
    return res.data;
  } catch (err) {
    throw err.response?.data || err.message;
  }
};

export const manualOverride = async (data) => {
  try {
    const res = await axios.post(`${ATT_BASE}/override`, data, getAuthHeaders());
    return res.data;
  } catch (err) {
    throw err.response?.data || err.message;
  }
};
